import type {
    SpeechCalibrationConfidence,
    SpeechCalibrationTrait,
} from '../admin/adminSpeechCalibrationApi';

export const SPEECH_CALIBRATION_RATER_TAG = 'speech_calibration_rater';
export const SPEECH_CALIBRATION_ADJUDICATOR_TAG = 'speech_calibration_adjudicator';
export const SPEECH_CALIBRATION_RELEASE_MANAGER_TAG = 'speech_calibration_release_manager';

export function hasSpeechCalibrationPermission(
    permissions: unknown,
    requiredTags: string[],
) {
    const tags = Array.isArray(permissions)
        ? permissions.map((value) => String(value).trim().toLowerCase())
        : [];
    return requiredTags.some((tag) => tags.includes(tag));
}

export const calibrationTraits: SpeechCalibrationTrait[] = [
    'pronunciation',
    'fluency',
    'prosody',
    'clarity',
];

export const calibrationTraitLabels: Record<SpeechCalibrationTrait, string> = {
    pronunciation: 'Pronunciation',
    fluency: 'Fluency',
    prosody: 'Prosody',
    clarity: 'Clarity',
};

export const confidenceOptions: Array<{
    value: SpeechCalibrationConfidence;
    label: string;
}> = [
    { value: 'low', label: 'Low confidence' },
    { value: 'medium', label: 'Medium confidence' },
    { value: 'high', label: 'High confidence' },
];

export function todayUtc() {
    return new Date().toISOString().slice(0, 10);
}

export function addUtcDays(value: string, days: number) {
    const date = new Date(`${value}T00:00:00.000Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
}

export function formatDateTime(value: string | null | undefined) {
    if (!value) return '—';
    return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
        timeZoneName: 'short',
    }).format(new Date(value));
}

export function formatDuration(seconds: number | null | undefined) {
    if (seconds == null) return '—';
    if (seconds < 60) return `${Math.round(seconds)}s`;
    const minutes = Math.floor(seconds / 60);
    const remainder = Math.round(seconds % 60);
    return `${minutes}m ${remainder}s`;
}

export function statusColor(status: string): 'default' | 'success' | 'warning' | 'error' | 'info' {
    const normalized = status.toLowerCase();
    if (normalized.includes('complete') || normalized.includes('compared') || normalized.includes('ready')) return 'success';
    if (normalized.includes('pending') || normalized.includes('blind')) return 'info';
    if (normalized.includes('adjudicat') || normalized.includes('review')) return 'warning';
    if (normalized.includes('unusable') || normalized.includes('fail') || normalized.includes('blocked')) return 'error';
    return 'default';
}
